import * as MenuItems from "./MenuItems";
import { LocationMenuItemModel } from "../models/LocationMenuItemModel";

export const UDISTRICT_MENU_ITEMS: {
  [sectionName: string]: LocationMenuItemModel[];
} = {
  Specialties: [
    {
      menuItem: MenuItems.LambNoodles,
      price: 13.99,
    },
    {
      menuItem: MenuItems.BeefNoodles,
      price: 13.99,
    },
    {
      menuItem: MenuItems.LambNoodleSoup,
      price: 14.99,
    },
    {
      menuItem: MenuItems.BeefNoodleSoup,
      price: 14.99,
    },
    {
      menuItem: MenuItems.LambSkewers,
      price: 6.99,
    },
    {
      menuItem: MenuItems.ChickenWingSkewers,
      price: 12,
    },
    {
      menuItem: MenuItems.PorkWontonsChiliSauce,
      price: 8.99,
    },
    {
      menuItem: MenuItems.ChickenPotstickers,
      price: 8.99,
    },
    {
      menuItem: MenuItems.ThreeFlavorDumplings,
      price: 11.99,
    },
  ],
  Starters: [
    {
      menuItem: MenuItems.CucumberSalad,
      price: 7.99,
    },
    {
      menuItem: MenuItems.BroccoliGarlicSauce,
      price: 7.99,
    },
    {
      menuItem: MenuItems.PotatoSalad,
      price: 7.99,
    },
    {
      menuItem: MenuItems.BeanSprouts,
      price: 7.99,
    },
    {
      menuItem: MenuItems.WoodEarMushrooms,
      price: 6.99,
    },
    {
      menuItem: MenuItems.Edamame,
      price: 6.99,
    },
    {
      menuItem: MenuItems.LotusRoot,
      price: 9.99,
    },
    {
      menuItem: MenuItems.HandPulledLamb,
      price: 12.99,
    },
    {
      menuItem: MenuItems.MarinatedPorkIntestine,
      price: 9.99,
    },
    {
      menuItem: MenuItems.SichuanSlicedBeef,
      price: 9.99,
    },
    {
      menuItem: MenuItems.MouthwateringChickenChiliOil,
      price: 9.99,
    },
  ],
  "Biang Biang Noodles": [
    {
      menuItem: MenuItems.LambNoodles,
      price: 13.99,
    },
    {
      menuItem: MenuItems.BeefNoodles,
      price: 13.99,
    },
    {
      menuItem: MenuItems.BraisedPorkNoodles,
      price: 13.99,
    },
    {
      menuItem: MenuItems.HotOilNoodles,
      price: 13.99,
    },
    {
      menuItem: MenuItems.TomatoEggNoodles,
      price: 14.99,
    },
    {
      menuItem: MenuItems.VegetableNoodles,
      price: 13.99,
    },
    {
      menuItem: MenuItems.QishanPorkNoodles,
      price: 13.99,
    },
    {
      menuItem: MenuItems.MouthwateringChickenNoodles,
      price: 13.99,
    },
  ],
  "Biang Biang Noodle Soup": [
    {
      menuItem: MenuItems.LambNoodleSoup,
      price: 14.99,
    },
    {
      menuItem: MenuItems.BeefNoodleSoup,
      price: 14.99,
    },
    {
      menuItem: MenuItems.BraisedPorkNoodleSoup,
      price: 14.99,
    },
    {
      menuItem: MenuItems.VegetableNoodleSoup,
      price: 13.99,
    },
    {
      menuItem: MenuItems.QishanPorkNoodleSoup,
      price: 14.99,
    },
  ],
  "Rice Noodle Soup": [
    {
      menuItem: MenuItems.LambRiceNoodleSoup,
      price: 14.99,
    },
    {
      menuItem: MenuItems.BeefRiceNoodleSoup,
      price: 14.99,
    },
    {
      menuItem: MenuItems.PorkIntestineRiceNoodleSoup,
      price: 14.99,
    },
    {
      menuItem: MenuItems.BoneBrothRiceNoodleSoup,
      price: 11.99,
    },
    {
      menuItem: MenuItems.SpicyTinglyRiceNoodleSoup,
      price: 11.99,
    },
    {
      menuItem: MenuItems.HotSourRiceNoodleSoup,
      price: 11.99,
    },
  ],
  Skewers: [
    {
      menuItem: MenuItems.LambSkewers,
      price: 6.99,
    },
    {
      menuItem: MenuItems.BeefSkewers,
      price: 6.99,
    },
    {
      menuItem: MenuItems.ChickenWingSkewers,
      price: 12,
    },
    {
      menuItem: MenuItems.FishTofuSkewers,
      price: 5.99,
    },
    {
      menuItem: MenuItems.GrilledMackerelSkewer,
      price: 6.99,
    },
    {
      menuItem: MenuItems.GrilledPorkBellySkewers,
      price: 5.99,
    },
    {
      menuItem: MenuItems.ChickenGizzardSkewers,
      price: 5.99,
    },
    {
      menuItem: MenuItems.GrilledQuailSkewers,
      price: 15,
    },
  ],
  "Street Food": [
    {
      menuItem: MenuItems.LambBun,
      price: 8.5,
    },
    {
      menuItem: MenuItems.BeefBun,
      price: 7.5,
    },
    {
      menuItem: MenuItems.PorkBun,
      price: 7.5,
    },
    {
      menuItem: MenuItems.PorkWontonsChiliSauce,
      price: 8.99,
    },
    {
      menuItem: MenuItems.ChickenPotstickers,
      price: 8.99,
    },
    {
      menuItem: MenuItems.PorkDumplings,
      price: 11.99,
    },
    {
      menuItem: MenuItems.LambDumplings,
      price: 13.99,
    },
    {
      menuItem: MenuItems.ThreeFlavorDumplings,
      price: 11.99,
    },
    {
      menuItem: MenuItems.SpringRolls,
      price: 4.99,
    },
    {
      menuItem: MenuItems.HotSourRiceNoodles,
      price: 9.99,
    },
    {
      menuItem: MenuItems.LambSoup,
      price: 13.99,
    },
    {
      menuItem: MenuItems.LambPaoMo,
      price: 14.99,
    },
    {
      menuItem: MenuItems.LambHaggisSoup,
      price: 15.99,
    },
  ],
  Extras: [
    {
      menuItem: MenuItems.PlainBun,
      price: 3,
    },
    { menuItem: MenuItems.WhiteRice, price: 3 },
    {
      menuItem: MenuItems.StewedPorkRice,
      price: 9.99,
    },
    {
      menuItem: MenuItems.ColdNoodles,
      price: 9,
    },
  ],
  Beverages: [
    {
      menuItem: MenuItems.BottledWater,
      price: 1.5,
    },
    {
      menuItem: MenuItems.SweetTea,
      price: 3.5,
    },
    {
      menuItem: MenuItems.ArcticOceanTangerineSoda,
      price: 3.5,
    },
    {
      menuItem: MenuItems.FountainSoda,
      price: 1.99,
    },
    {
      menuItem: MenuItems.MilkTea,
      price: 5,
    },
    {
      menuItem: MenuItems.FruitSmoothie,
      price: 5,
    },
  ],
};
